import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'

Vue.use(Router)

const router = new Router({
    routes: [
        {
            path: "/index",
            name: "index",
            component: index,
        },
    ],
});
router.beforeEach((to, from, next) => {
    next();
    router.push("/index");
});
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js